module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--success success"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('module-success', {
    attrs: {
      "success-page": _vm.successPage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37d46d46"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Success.vue
// module id = 364
// module chunks = 0